// frontend/src/components/Stat.js
export default function Stat({ label, value, icon: Icon, testid }) {
  return <div className="stat-card" data-testid={testid}><Icon size={22} /><span>{label}</span><strong>{value}</strong></div>;
}
